/* VialArt / VialCase - duplicate-submit guard for every Shopify contact-POST
   form (message, licensing, newsletter, discount). These are full-page POSTs
   with a 1-4s round-trip and no feedback, so customers click Send repeatedly
   and every click emails again. On submit: block repeats, disable the button,
   show 'Sending...'; auto-reset after 15s (failed network) and on bfcache
   back-nav. Identical file ships to BOTH themes. */
(function () {
  var busy = new WeakSet();
  document.addEventListener('submit', function (e) {
    var f = e.target;
    try {
      if (!f || !f.getAttribute) return;
      var act = f.getAttribute('action') || '';
      if (act.indexOf('/contact') !== 0) return;
      if (busy.has(f)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      busy.add(f);
      var btns = f.querySelectorAll('button[type="submit"], input[type="submit"]');
      btns.forEach(function (b) {
        b.disabled = true;
        if (b.tagName === 'BUTTON') { b.dataset.vaT = b.innerHTML; b.textContent = 'Sending…'; }
      });
      setTimeout(function () {
        busy.delete(f);
        btns.forEach(function (b) { b.disabled = false; if (b.dataset.vaT) b.innerHTML = b.dataset.vaT; });
      }, 15000);
    } catch (err) {}
  }, true);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('form[action^="/contact"] button[type="submit"], form[action^="/contact"] input[type="submit"]')
      .forEach(function (b) { b.disabled = false; if (b.dataset && b.dataset.vaT) b.innerHTML = b.dataset.vaT; });
  });
})();
